import useModelContext from './useModelContext';
export default function useKeyAuthToken() {
  const keyAuthToken = useModelContext(s => s.keyAuthToken);
  if (!keyAuthToken) {
    throw new Error('"keyAuthToken" is missing');
  }
  return keyAuthToken || '';
}